import { PasswordInput } from '@/components/blocks/PasswordInput';
import { REG_EX } from '@/utils/address';
import { EMPTY_STRING } from '@/data/constants/marketing';
import { useForm } from '@/utils/useForm';
import ClearIcon from '@mui/icons-material/Clear';

import { Box, ButtonBase, IconButton, Modal, Stack, TextField, Typography } from '@mui/material';
import { FC } from 'react';
import {
	ConfirmCredentialsDialogCancelButtonSX,
	ConfirmCredentialsDialogContentSX,
	ConfirmCredentialsDialogEmailSX,
	ConfirmCredentialsDialogHeaderSX,
	ConfirmCredentialsDialogPasswordSX,
	ConfirmCredentialsDialogSubmitButtonSX,
	ConfirmCredentialsDialogTitleSX,
} from '@/components/blocks/ConfirmCredentialsDialog/style';

const initialForm = {
	email: '',
	password: '',
};

type Props = {
	open: boolean;
	title: string;
	description?: string;
	buttonCancelLabel?: string;
	buttonConfirmLabel?: string;
	onClose: () => void;
	onSubmit: (value: { email: string; password: string }) => void;
};

export const ConfirmCredentialsDialog: FC<Props> = ({
	open,
	title,
	description,
	buttonCancelLabel,
	buttonConfirmLabel,
	onClose,
	onSubmit,
}) => {
	const {
		handleInputChange,
		values: loginValues,
		formRef,
		error,
		handleSubmit,
		submitting,
	} = useForm(initialForm);

	return (
		<Modal open={open}>
			<Box sx={ConfirmCredentialsDialogContentSX}>
				<Stack sx={ConfirmCredentialsDialogHeaderSX}>
					<Box />
					<IconButton onClick={onClose}>
						<ClearIcon />
					</IconButton>
				</Stack>
				<Stack
					spacing={2}
					component="form"
					onSubmit={handleSubmit(onSubmit)}
					noValidate
					ref={formRef}
					padding="0px 20px 20px 20px"
				>
					<Stack spacing={0.5}>
						<Typography sx={ConfirmCredentialsDialogTitleSX}>{title}</Typography>
						{description ? <Typography>{description}</Typography> : null}
					</Stack>
					<TextField
						sx={ConfirmCredentialsDialogEmailSX}
						variant="outlined"
						margin="normal"
						required
						name="email"
						autoComplete="username"
						label="Correo electrónico"
						value={loginValues.email}
						onChange={handleInputChange}
						inputProps={{
							maxLength: 100,
							type: 'email',
							pattern: REG_EX.EMAIL.source,
						}}
						error={error.email}
						helperText={error.email ? 'Correo electrónico inválido' : EMPTY_STRING}
					/>

					<PasswordInput
						sx={ConfirmCredentialsDialogPasswordSX}
						required
						name="password"
						label="Contraseña"
						value={loginValues.password}
						onChange={handleInputChange}
						error={error.password}
						inputProps={{
							maxLength: 100,
						}}
						helperText={error.password ? 'Contraseña inválida' : EMPTY_STRING}
					/>
					<Stack spacing={2}>
						<Stack direction="row" alignItems="center" spacing={2}>
							<ButtonBase
								type="submit"
								disabled={submitting}
								sx={ConfirmCredentialsDialogCancelButtonSX}
								onClick={onClose}
							>
								{buttonCancelLabel || 'Cancelar'}
							</ButtonBase>
							<ButtonBase
								type="submit"
								disabled={submitting}
								sx={ConfirmCredentialsDialogSubmitButtonSX}
							>
								{buttonConfirmLabel || 'Confirmar'}
							</ButtonBase>
						</Stack>
					</Stack>
				</Stack>
			</Box>
		</Modal>
	);
};
